<template>
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 2v8"/>
    <polyline points="5 7 8 10 11 7"/>
    <path d="M3 13h10"/>
  </svg>
</template>
